import { isMobile } from '@farmasiet/frontendcore-reactcomponents';
import * as React from 'react';

import { getTranslation, keys } from '../../../Resources/Translations';
import Accordion, { ItemStatus } from '../../ReactComponents/Accordion/Accordion';
import AccordionItem from '../../ReactComponents/Accordion/AccordionItem';
import { ComponentProps } from '../../ReactComponents/ComponentProps.csharp';
import { RenderHTML } from '../../ReactComponents/RenderHTML';
import { ProductInformationSectionViewModel } from './ProductInformationSectionViewModel.csharp';
import { ProductInformationViewModel } from './ProductInformationViewModel.csharp';

export const ProductInformation: React.FC<ComponentProps<ProductInformationViewModel>> = ({ model }) => {
    const updateItemsStatus = (items: ProductInformationSectionViewModel[]) => {
        return items.map((item, index) => {
            return {
                isActive: index === 0 && !isMobile(),
                isExpanded: index !== 0 || isMobile()
            };
        });
    };

    const [itemsStatus, setItemsStatus] = React.useState<ItemStatus[]>(updateItemsStatus(model.sections));

    return (
        <div className="ProductInformation">
            <Accordion
                allowMultipleItems
                itemsStatus={itemsStatus}
                collapsedItemMaxHeight={500}
                showMoreIndicator={<span className="ProductInformation__ShowMore">{getTranslation(keys['productInformation.showMore'])}</span>}
                onActiveItemChanged={(changedItemsStatus) => setItemsStatus(changedItemsStatus)}
                labelClassName="ProductInformation__Heading"
            >
                {model.sections.map((section: ProductInformationSectionViewModel) => (
                    <AccordionItem key={section.heading} label={section.heading}>
                        {section.text && <RenderHTML className="ProductInformation__Text" html={section.text} />}
                        {section.tableData && section.tableData.length > 0 && (
                            <table className="ProductInformation__Table">
                                <tbody>
                                    {section.tableData.map((tableRow) => (
                                        <tr key={tableRow.key}>
                                            <td>{tableRow.key}</td>
                                            <td>
                                                {tableRow.link ? (
                                                    <a href={tableRow.link} target="_blank" rel="noreferrer">
                                                        <RenderHTML html={tableRow.value} />
                                                    </a>
                                                ) : (
                                                    <RenderHTML html={tableRow.value} />
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}

                        {section.codes && (
                            <table className="ProductInformation__Codes">
                                <tbody>
                                    {section.codes.map((tableRow) => (
                                        <tr key={tableRow.key}>
                                            <td>{tableRow.key}</td>
                                            <td>{tableRow.value}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}

                        {section.ingredients && <div className="ProductInformation__Ingredients">{section.ingredients}</div>}

                        {section.entityLink && (
                            <a href={section.entityLink} target="_blank" className="ProductInformation__PimLink" rel="noreferrer">
                                <span>Endre i PIM</span>
                            </a>
                        )}
                    </AccordionItem>
                ))}
            </Accordion>
        </div>
    );
};
